<swiper-container init="false" #swiper>
  <ng-content></ng-content>
</swiper-container>

<div class="custom-navigation" role="group" aria-label="Swiper Navigation">
  <button class="prev-button" type="button" aria-label="Vorherige Seite">
    <svg-icon src="assets/images/icons/arrow.svg" class="arrow-icon" aria-hidden="true"></svg-icon>
  </button>

  <div class="pagination-wrapper" role="group" aria-label="Seiten">
    <!-- Swiper's pagination will render here -->
  </div>

  <button class="next-button" type="button" aria-label="Nächste Seite">
    <svg-icon src="assets/images/icons/arrow.svg" class="arrow-icon" aria-hidden="true"></svg-icon>
  </button>
</div>
